import { faCode, faLayerGroup, faMobileScreen } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React from 'react'

const Services = () => {
    const services = [
        {
            id: 1,
            name: 'Web Development',
            des: 'I am a MERN Stack Developer. Can develope a functional website using this Stack.',
            img: <FontAwesomeIcon icon={faCode} />
        },
        {
            id: 2,
            name: 'Responsive Site',
            des: 'I can develop any sort of responsive website.',
            img: <FontAwesomeIcon icon={faMobileScreen} />
        },
        {
            id: 3,
            name: 'Web Design',
            des: 'I have a good design sense that makes a website outstanding.',
            img: <FontAwesomeIcon icon={faLayerGroup} />
        }
    ]

    return (
        <div id="service" className="my-20 max-w-7xl mx-auto px-10">
            <h2 className="text-4xl text-warning text-center font-bold tracking-wider">My Services</h2>
            <div className="grid lg:grid-cols-3 gap-10 mt-10">
                {services.map(service => (
                    <div
                        data-aos="zoom-out"
                        data-aos-duration="2000"
                        class="card card-compact max-w-md bg-base-100 shadow-2xl text-success hover:bg-base-200 hover:transition-all"
                    >
                        <p className="text-center text-success text-3xl mt-3">{service.img}</p>
                        <div class="card-body">
                            <h2 class="card-title mx-auto">{service.name}</h2>
                            <p className="text-base">{service.des}</p>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    )
}

export default Services
